import styled from 'styled-components';

export const CheckoutItemBlock = styled.div`
  width: 100%;
  display: flex;
  min-height: 100px;
  border-bottom: 1px solid darkgrey;
  padding: 15px 0;
  font-size: 20px;
  align-items: center;
`;
export const ImgContainer = styled.div`
  width: 23%;
  padding-right: 15px;
  img {
    width: 100%;
    height: 100%;
  }
`;
export const Arrow = styled.div`
  cursor: pointer;
`;

export const RemoveBtn = styled.div`
  padding-left: 12px;
  cursor: pointer;
`;

export const Name = styled.span`
  width: 23%;
`;
export const Price = styled.span`
  width: 23%;
`;
export const Quantity = styled.span`
  width: 23%;
  display: flex;
`;
export const Value = styled.span`
  margin: 0 10px;
`;
